var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgCta = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeLinejoin: "round", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M7.313.75v3.375M4.125 7.313H.75m8.813-2.25 2.624-2.625M5.063 5.063 2.438 2.438m2.625 7.125-2.625 2.624m13.125 1.876-3.057-3.057 2.689-1.087-9.007-3.732 3.73 9.008 1.088-2.689 3.057 3.057z" }) }))); };
export default SvgCta;
